import { CityMultiLingualDTO, Street } from "@lg-cfa/services";
import { useEffect, useState } from "react";

import {
    ApiResponseInterface,
    SelectBoxInterface,
    UserDataInterface,
} from "@types";

export function useApiDataFormat(
    formData: UserDataInterface,
    B2BCities: Array<CityMultiLingualDTO>,
    B2BStreets: Array<Street> | undefined,
    language: string,
) {
    const [apiData, setApiData] = useState<ApiResponseInterface | undefined>(
        undefined,
    );
    const innerLanguage = language === "nl-BE" ? "NLD" : "FRA";

    useEffect(() => {
        setApiData((apiData) => ({
            ...apiData,
            propertyStreet:
                B2BStreets && B2BStreets.length > 0
                    ? (B2BStreets.map((s) => {
                          return { value: s.id, label: s.name };
                      }) as Array<SelectBoxInterface>)
                    : undefined,
            propertyCity:
                B2BCities.length > 0
                    ? (B2BCities.map((c) => {
                          const generatedLabel = `${c.postalCode} - ${
                              c?.names ? c.names[innerLanguage] : ""
                          }`;

                          return { value: c.id, label: generatedLabel };
                      }) as Array<SelectBoxInterface>)
                    : undefined,
        }));
    }, [formData, B2BCities, B2BStreets, innerLanguage]);

    return apiData;
}
